const Builder = require('./BuilderBase');
const HiddenFor = require('./HiddenFor');
const CustomizableVisibility = require('./CustomizableVisibility');
const ReadOnlyFor = require('./ReadOnlyFor');
const SingleRecordForm = require('./SingleRecordForm');

module.exports = class DetailPane extends Builder {
    constructor(title, properties) {
        super('detailPane_DetailPane', title, properties);
    }

    form(title, properties) {
        let form = new Builder.blockTypes['Form'](title, properties);
        this.addChildBlock(form);
        return form;
    }

    singleRecordForm(title, properties = {}) {
        let propertyKeys = Object.keys(properties);
        if (!propertyKeys.includes('namespace') || !propertyKeys.includes('relation')) {
            throw new Error('You must specify "namespace" and "relation" properties for the Form');
        }

        let layout = new Builder.blockTypes['Layout']('testLayout', {
            defaultNamespace: properties.namespace,
            defaultRelation: properties.relation
        });

        this.addChildBlock(layout);

        let singleRecordForm = new SingleRecordForm(title, properties);
        layout.addChildBlock(singleRecordForm);
        return singleRecordForm;
    }
    /**
     *
     * @param {object} properties
     * @param {string} properties.title
     * @param {boolean} properties.isTabAccess
     * @param {string} properties.accessTargetId
     * @param {boolean} properties.readOnly
     */
    customizableVisibility(properties) {
        let modifier = new CustomizableVisibility(properties);
        this.addChildBlock(modifier, 'securityModifier');
        return this;
    }

    hiddenFor(role) {
        let hiddenFor = new HiddenFor(role);
        this.addChildBlock(hiddenFor, 'securityModifier');
        return this;
    }

    readOnlyFor(role) {
        let readOnlyFor = new ReadOnlyFor(role);
        this.addChildBlock(readOnlyFor, 'securityModifier');
        return this;
    }
};
